/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import { useNotification, PageLoader, Wrapper } from '@cloudpilots/components';
import PropTypes from 'prop-types';
import React, { useState, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { config, menu, routes, scopes } from '../config';
import Api from 'services/Api';

const Content = (props) => {
  const { notify } = useNotification();
  const [isReady, setIsReady] = useState(false);

  const onDidMount = async (Caba) => {
    console.log('caba', Caba);

    try {
      console.log('on app did mount', Caba);
      await Api.init(Caba.getToken());

      // set app ready
      setIsReady(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Suspense fallback={<PageLoader isLoading hasColor isFixed />}>
      <Router>
        <Wrapper
          isReady={isReady}
          appName={config.appName}
          routes={routes}
          scopes={scopes}
          menu={menu}
          viewProps={{
            notify: (...args) => notify(...args),
          }}
          onDidMount={onDidMount}
          {...props}
        />
      </Router>
    </Suspense>
  );
};

Content.propTypes = {
  children: PropTypes.any,
};

export default Content;
